/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T08:26:50.716
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseSalesPromotion,
	listRentHouseSalesPromotionInit,
	listRentHouseSalesPromotionByAuthorizations,
	deleteRentHouseSalesPromotion
	
} from '@api/rentmanage/RentHouseSalesPromotion';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseSalesPromotion({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesPromotion(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseSalesPromotionByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesPromotionByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseSalesPromotionInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesPromotionInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseSalesPromotion({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseSalesPromotion({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
